import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import * as mockData from './data/mock';

// 导入页面组件
import Home from './pages/Home';
import Category from './pages/Category';
import ProductDetail from './pages/ProductDetail';
import EnergyCalculator from './pages/EnergyCalculator';
import SearchResults from './pages/SearchResults';
import AboutCrystals from './pages/AboutCrystals';

// 工具类页面
import Calculators from './pages/Calculators';
import Tutorials from './pages/Tutorials';
import Inspiration from './pages/Inspiration';
import Knowledge from './pages/Knowledge';
import Tools from './pages/Tools';

// 具体工具页面
import CostEstimator from './pages/tools/CostEstimator';
import SizeConverter from './pages/tools/SizeConverter';
import AppraisalInstitutions from './pages/tools/AppraisalInstitutions';
import CrystalIdentification from './pages/tools/CrystalIdentification';
import ColorPalette from './pages/tools/ColorPalette';
import TutorialSteps from './pages/tools/TutorialSteps';
import FAQ from './pages/tools/FAQ';
import TemplateDownload from './pages/tools/TemplateDownload';
import MaintenanceTips from './pages/tools/MaintenanceTips';
import MaterialComparison from './pages/tools/MaterialComparison';
import CustomForm from './pages/tools/CustomForm';
import QRCodeGenerator from './pages/tools/QRCodeGenerator';
import BraceletCalculator from './pages/tools/BraceletCalculator';

// 导入共用组件
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  const {
    products,
    crystalTypes,
    jewelryCategories,
    productDetails,
    carouselItems,
  } = mockData;

  return (
    <Router>
      <div className="App min-h-screen flex flex-col bg-gradient-to-br from-purple-100 to-blue-100">
        <Navbar categories={jewelryCategories} crystalTypes={crystalTypes} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home products={products} carouselItems={carouselItems} />} />
            <Route path="/category/:categoryId?" element={<Category products={products} crystalTypes={crystalTypes} categories={jewelryCategories} />} />
            <Route path="/product/:productId" element={<ProductDetail products={productDetails} allProducts={products} />} />
            <Route path="/energy-calculator" element={<EnergyCalculator />} />
            <Route path="/search" element={<SearchResults products={products} />} />
            <Route path="/about-crystals" element={<AboutCrystals />} />
            
            {/* 工具分类页面 */}
            <Route path="/calculators" element={<Calculators />} />
            <Route path="/tutorials" element={<Tutorials />} />
            <Route path="/inspiration" element={<Inspiration />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/tools" element={<Tools />} />
            
            {/* 具体工具页面 */}
            <Route path="/calculators/cost-estimator" element={<CostEstimator />} />
            <Route path="/calculators/size-converter" element={<SizeConverter />} />
            <Route path="/calculators/bracelet-calculator" element={<BraceletCalculator />} />
            <Route path="/knowledge/appraisal-institutions" element={<AppraisalInstitutions />} />
            <Route path="/knowledge/crystal-identification" element={<CrystalIdentification />} />
            <Route path="/inspiration/color-palette" element={<ColorPalette />} />
            <Route path="/tutorials/steps" element={<TutorialSteps />} />
            <Route path="/knowledge/faq" element={<FAQ />} />
            <Route path="/tools/template-download" element={<TemplateDownload />} />
            <Route path="/knowledge/maintenance-tips" element={<MaintenanceTips />} />
            <Route path="/knowledge/material-comparison" element={<MaterialComparison />} />
            <Route path="/tools/custom-form" element={<CustomForm />} />
            <Route path="/tools/qrcode-generator" element={<QRCodeGenerator />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;